module.exports = __webpack_public_path__ + "static/img/7.839dd6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/7.png
// module id = GRtW
// module chunks = 0